export default __webpack_public_path__ + "images/oxfav.ddaaff49c7206d1517f226a9045936a9.png";